import { useState } from 'react'
import './index.scss'
import {
  AutomatedTrafficFineNotificationAuthenticationHideInfo,
  AutomatedTrafficFineNotificationAuthenticationShowInfo
} from '../../../../assets/icons'
import { useAppUserContext } from '../../../../context/AppUserContext'
import SafeImage from '../../../../components/BasicComponent/SafeImage'

export default function AutomatedTrafficFineNotificationAuthenticationInfo({ description = '', isError = false }) {
  const [hideInfo, setHideInfo] = useState(true)
  const { userData, pendingUserData, isLoadingUserData } = useAppUserContext()
  const currentUserData = pendingUserData?.phoneNumberWithUsernamePrefix ? pendingUserData : userData

  const displayUserData = [
    ...(currentUserData?.fullName
      ? [
          {
            label: 'Họ tên',
            value: isError ? '' : currentUserData.fullName
          }
        ]
      : []),
    {
      label: 'Số điện thoại',
      value: isError ? '' : currentUserData?.phoneNumberFromSdk || ''
    }
  ]

  return (
    <div className="AutomatedTrafficFineNotificationAuthenticationInfo">
      <SafeImage className="AuthenticationInfo_img" src="/logoFull.png" />
      <div className={`AuthenticationInfo_attention ${isError ? 'AuthenticationInfo_attention_error' : ''}`}>{description}</div>

      <div className="AuthenticationInfo_carInfo">
        <div className="AuthenticationInfo_carInfo_hideInfo" onClick={() => setHideInfo(!hideInfo)}>
          {hideInfo ? <AutomatedTrafficFineNotificationAuthenticationHideInfo /> : <AutomatedTrafficFineNotificationAuthenticationShowInfo />}
          {hideInfo ? (
            <div className="AuthenticationInfo_carInfo_hideInfo_text">Ẩn thông tin</div>
          ) : (
            <div className="AuthenticationInfo_carInfo_hideInfo_text">Hiện thông tin</div>
          )}
        </div>

        {isLoadingUserData && <div className="AuthenticationInfo_carInfo_loading">Đang lấy thông tin...</div>}

        {!isLoadingUserData &&
          displayUserData.map((item) => (
            <div key={item.label} className="AuthenticationInfo_carInfo_item">
              <div className="AuthenticationInfo_carInfo_item_label">{item.label}</div>
              <div className="AuthenticationInfo_carInfo_item_value">
                {item.value ? (hideInfo ? '*********' : <strong>{item.value}</strong>) : ''}
              </div>
            </div>
          ))}

        {/* Tạm ẩn ô nhập số điện thoại. Khi cần mở lại cho flow khác thì gắn logic sau. */}
      </div>

      <div className="AuthenticationInfo_purpose">
        <p className="AuthenticationInfo_purpose_title">Mục đích chia sẻ, xử lý dữ liệu:</p>
        <p className="AuthenticationInfo_purpose_content">
          Các trường thông tin trên được chia sẻ để phục vụ đánh giá và cung cấp các sản phẩm, dịch vụ cho Quý khách.
        </p>
      </div>
    </div>
  )
}
